import {DeviceInfoData} from "deviceDataTypes";
import axiostool from "./axiostool";

const BASE = "api/register";

export const getLastData = (deviceType: string,prd_id: string) => {
  return axiostool.get(`/${BASE}/getlastinfo/${deviceType}/${prd_id}`);
};
export const pushLastData = (device: string, data: DeviceInfoData) => {
  return axiostool.put(`/${BASE}/getlastinfo/${device}/${data.prd_id}`, data);
};
export const addLastData = (device: string, data: DeviceInfoData) => {
    return axiostool.post(`/${BASE}/getlastinfo/${device}`, data);
};
export const deleteLastData = (device: string, data: DeviceInfoData) => {
  return axiostool.delete(`/${BASE}/getlastinfo/${device}/${data.prd_id}`);
};
export const getAllData = (
  device: string,
  search: string,
  searchType: "name" | "prd_id"
) => {
  return axiostool.get(
    `/${BASE}/getallinfodata/${device}?search=${search}&searchType=${searchType}`
  );
};

export const getSpotData = (id:string) =>{
  return axiostool.get(
    `/${BASE}/getspotdata/${id}`
  )
}
